module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item) ? _c('div', {
    staticClass: "component component-backoffice-reservation",
    class: _vm.item.status
  }, [(_vm.$is('listing')) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [(_vm.$is('listing')) ? _c('CardN', {
    attrs: {
      "showBullets": true,
      "showAction": true,
      "columns": 6
    }
  }, [_c('div', {
    staticClass: "field-reservation-dropdown-buttons",
    attrs: {
      "slot": "actionBullets"
    },
    slot: "actionBullets"
  }, [_c('dropdown', {
    attrs: {
      "icon": 'fa fa-ellipsis-v fa-2x action',
      "position": 'top'
    }
  }, [_c('reservation-action-buttons', {
    attrs: {
      "reservation": _vm.item
    }
  })], 1)], 1), _c('div', {
    staticClass: "field-reservation-info",
    attrs: {
      "slot": "n1"
    },
    slot: "n1"
  }, [_c('reservation-fields', {
    attrs: {
      "item": _vm.item,
      "fieldName": 'reservation-id',
      "type": 'reservation-id'
    }
  }), _c('driver', {
    attrs: {
      "type": 'onlyname',
      "item": _vm.item.driver
    }
  })], 1), _c('reservation-fields', {
    attrs: {
      "slot": "n1",
      "item": _vm.item,
      "fieldName": 'reservation-bmode'
    },
    slot: "n1"
  }), _c('reservation-fields', {
    attrs: {
      "slot": "n2",
      "fieldName": 'vehicle-info',
      "item": _vm.item
    },
    slot: "n2"
  }), _c('reservation-fields', {
    attrs: {
      "slot": "n3",
      "item": _vm.item,
      "fieldName": 'reservation-start'
    },
    slot: "n3"
  }), _c('reservation-fields', {
    attrs: {
      "slot": "n4",
      "item": _vm.item,
      "fieldName": 'reservation-distance'
    },
    slot: "n4"
  }), _c('reservation-fields', {
    attrs: {
      "slot": "n4",
      "item": _vm.item,
      "fieldName": 'reservation-cost'
    },
    slot: "n4"
  }), _c('BackofficeReservation', {
    attrs: {
      "slot": "n5",
      "type": "start-end-position",
      "item": _vm.item
    },
    slot: "n5"
  }), _c('reservation-fields', {
    attrs: {
      "slot": "n6",
      "item": _vm.item,
      "fieldName": 'reservation-status'
    },
    slot: "n6"
  }), _c('div', {
    staticClass: "field-url-detail",
    attrs: {
      "slot": "actionPage"
    },
    slot: "actionPage"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'reservation',
        params: {
          id: _vm.item.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right fa-3x action"
  })])], 1)], 1) : _vm._e()], 1), (_vm.item.status == 'STARTED') ? _c('div', {
    staticClass: "warning progress pm-progress thin"
  }, [_c('div', {
    staticClass: "progress-meter",
    staticStyle: {
      "width": "70%"
    }
  })]) : _vm._e()]) : _vm._e(), (_vm.$is('start-end-position')) ? _c('div', {
    staticClass: "start-end-position"
  }, [(_vm.item.booking_mode === 'OWFF') ? _c('div', {
    staticClass: "owff"
  }, [_c('div', {
    staticClass: "extra-info"
  }, [_vm._m(0), _c('span', [_vm._v("  " + _vm._s(_vm.item.extra.owff.pickup.name))])]), (_vm.item.extra.owff.dropoff !== null) ? _c('div', {
    staticClass: "extra-info"
  }, [_vm._m(1), _c('span', [_vm._v("  " + _vm._s(_vm.item.extra.owff.dropoff.name))])]) : _vm._e()]) : _c('div', {
    staticClass: "parking-lot"
  }, [_vm._v("PL" + _vm._s(_vm.item.vehicle.parking_lot.id) + " " + _vm._s(_vm.item.vehicle.parking_lot.name))]), _c('div', {
    staticClass: "vehicle-slot"
  }, [_vm._v("VS" + _vm._s(_vm.item.vehicle.slot_id) + " " + _vm._s(_vm.item.vehicle.vehicle_slot_address))])]) : _vm._e(), (_vm.$is('drv-res-list')) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('card9', {
    attrs: {
      "showBullets": true,
      "showAction": true
    }
  }, [_c('div', {
    staticClass: "field-reservation-dropdown-buttons",
    attrs: {
      "slot": "actionBullets"
    },
    slot: "actionBullets"
  }, [_c('dropdown', {
    attrs: {
      "icon": 'fa fa-ellipsis-v fa-2x action',
      "position": 'top'
    }
  }, [_c('reservation-action-buttons', {
    attrs: {
      "reservation": _vm.item
    }
  })], 1)], 1), _c('div', {
    staticClass: "field-reservation-info",
    attrs: {
      "slot": "n1"
    },
    slot: "n1"
  }, [_c('reservation-fields', {
    attrs: {
      "item": _vm.item,
      "fieldName": 'reservation-id',
      "type": 'reservation-id'
    }
  }), _c('img', {
    staticClass: "vehicle-picture",
    attrs: {
      "src": _vm.item.vehicle.picture_external
    }
  })], 1), _c('reservation-fields', {
    attrs: {
      "slot": "n2",
      "fieldName": 'vehicle-info',
      "item": _vm.item
    },
    slot: "n2"
  }), _c('div', {
    staticClass: "parking-lot",
    attrs: {
      "slot": "n2"
    },
    slot: "n2"
  }, [_vm._v("PL" + _vm._s(_vm.item.vehicle.parking_lot.id) + " " + _vm._s(_vm.item.vehicle.parking_lot.name))]), _c('reservation-fields', {
    attrs: {
      "slot": "n3",
      "item": _vm.item,
      "fieldName": 'reservation-start'
    },
    slot: "n3"
  }), _c('reservation-fields', {
    attrs: {
      "slot": "n4",
      "item": _vm.item,
      "fieldName": 'reservation-end'
    },
    slot: "n4"
  }), _c('reservation-fields', {
    attrs: {
      "slot": "n5",
      "item": _vm.item,
      "fieldName": 'reservation-bmode'
    },
    slot: "n5"
  }), _c('reservation-fields', {
    attrs: {
      "slot": "n6",
      "item": _vm.item,
      "fieldName": 'reservation-distance'
    },
    slot: "n6"
  }), _c('reservation-fields', {
    attrs: {
      "slot": "n7",
      "item": _vm.item,
      "fieldName": 'reservation-hours'
    },
    slot: "n7"
  }), _c('reservation-fields', {
    attrs: {
      "slot": "n8",
      "item": _vm.item,
      "fieldName": 'reservation-cost'
    },
    slot: "n8"
  }), _c('reservation-fields', {
    attrs: {
      "slot": "n9",
      "item": _vm.item,
      "fieldName": 'reservation-status'
    },
    slot: "n9"
  }), _c('div', {
    staticClass: "field-url-detail",
    attrs: {
      "slot": "actionPage"
    },
    slot: "actionPage"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'reservation',
        params: {
          id: _vm.item.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right fa-3x action"
  })])], 1)], 1)], 1), (_vm.item.status == 'STARTED') ? _c('div', {
    staticClass: "warning progress pm-progress thin"
  }, [_c('div', {
    staticClass: "progress-meter",
    staticStyle: {
      "width": "70%"
    }
  })]) : _vm._e()]) : _vm._e(), (_vm.$is('client-list')) ? _c('div', {
    staticClass: "client-list"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('card9', {
    attrs: {
      "showBullets": true,
      "showAction": true
    }
  }, [_c('div', {
    staticClass: "field-reservation-dropdown-buttons",
    attrs: {
      "slot": "actionBullets"
    },
    slot: "actionBullets"
  }, [_c('dropdown', {
    attrs: {
      "icon": 'fa fa-ellipsis-v fa-2x action',
      "position": 'top'
    }
  }, [_c('reservation-action-buttons', {
    attrs: {
      "reservation": _vm.item
    }
  })], 1)], 1), _c('reservation-fields', {
    attrs: {
      "slot": "n1",
      "item": _vm.item,
      "fieldName": 'reservation-id'
    },
    slot: "n1"
  }), _c('div', {
    staticClass: "driver",
    attrs: {
      "slot": "n1"
    },
    slot: "n1"
  }, [_vm._v(_vm._s(_vm.item.driver.name) + " " + _vm._s(_vm.item.driver.surname))]), _c('reservation-fields', {
    attrs: {
      "slot": "n2",
      "fieldName": 'vehicle-info',
      "item": _vm.item
    },
    slot: "n2"
  }), _c('reservation-fields', {
    attrs: {
      "slot": "n3",
      "item": _vm.item,
      "fieldName": 'reservation-start'
    },
    slot: "n3"
  }), _c('reservation-fields', {
    attrs: {
      "slot": "n4",
      "item": _vm.item,
      "fieldName": 'reservation-end'
    },
    slot: "n4"
  }), _c('reservation-fields', {
    attrs: {
      "slot": "n5",
      "item": _vm.item,
      "fieldName": 'reservation-bmode'
    },
    slot: "n5"
  }), _c('reservation-fields', {
    attrs: {
      "slot": "n6",
      "item": _vm.item,
      "fieldName": 'reservation-distance'
    },
    slot: "n6"
  }), _c('reservation-fields', {
    attrs: {
      "slot": "n7",
      "item": _vm.item,
      "fieldName": 'reservation-hours'
    },
    slot: "n7"
  }), _c('reservation-fields', {
    attrs: {
      "slot": "n8",
      "item": _vm.item,
      "fieldName": 'reservation-cost'
    },
    slot: "n8"
  }), _c('reservation-fields', {
    attrs: {
      "slot": "n9",
      "item": _vm.item,
      "fieldName": 'reservation-status'
    },
    slot: "n9"
  }), _c('div', {
    staticClass: "field-url-detail",
    attrs: {
      "slot": "actionPage"
    },
    slot: "actionPage"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'reservation',
        params: {
          id: _vm.item.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right fa-3x action"
  })])], 1)], 1)], 1)])]) : _vm._e(), (_vm.$is('vehicle-list')) ? _c('div', {
    staticClass: "vehicle-list"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('CardN', {
    attrs: {
      "showBullets": true,
      "showAction": true,
      "columns": 6
    }
  }, [_c('div', {
    staticClass: "field-reservation-dropdown-buttons",
    attrs: {
      "slot": "actionBullets"
    },
    slot: "actionBullets"
  }, [_c('dropdown', {
    attrs: {
      "icon": 'fa fa-ellipsis-v fa-2x action',
      "position": 'top'
    }
  }, [_c('reservation-action-buttons', {
    attrs: {
      "reservation": _vm.item
    }
  })], 1)], 1), _c('div', {
    staticClass: "field-reservation-info",
    attrs: {
      "slot": "n1"
    },
    slot: "n1"
  }, [_c('reservation-fields', {
    attrs: {
      "item": _vm.item,
      "fieldName": 'reservation-id',
      "type": 'reservation-id'
    }
  }), _c('driver', {
    attrs: {
      "type": 'onlyname',
      "item": _vm.item.driver
    }
  })], 1), _c('reservation-fields', {
    attrs: {
      "slot": "n1",
      "item": _vm.item,
      "fieldName": 'reservation-bmode'
    },
    slot: "n1"
  }), _c('reservation-fields', {
    attrs: {
      "slot": "n2",
      "item": _vm.item,
      "fieldName": 'reservation-start'
    },
    slot: "n2"
  }), _c('reservation-fields', {
    attrs: {
      "slot": "n3",
      "item": _vm.item,
      "fieldName": 'reservation-distance'
    },
    slot: "n3"
  }), _c('reservation-fields', {
    attrs: {
      "slot": "n4",
      "item": _vm.item,
      "fieldName": 'reservation-cost'
    },
    slot: "n4"
  }), _c('BackofficeReservation', {
    attrs: {
      "slot": "n5",
      "type": "start-end-position",
      "item": _vm.item
    },
    slot: "n5"
  }), _c('reservation-fields', {
    attrs: {
      "slot": "n6",
      "item": _vm.item,
      "fieldName": 'reservation-status'
    },
    slot: "n6"
  }), _c('div', {
    staticClass: "field-url-detail",
    attrs: {
      "slot": "actionPage"
    },
    slot: "actionPage"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'reservation',
        params: {
          id: _vm.item.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right fa-3x action"
  })])], 1)], 1)], 1)])]) : _vm._e(), (_vm.$is('shortList')) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('card5', [_c('div', {
    staticClass: "field-url-detail",
    attrs: {
      "slot": "n1"
    },
    slot: "n1"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'reservation',
        params: {
          id: _vm.item.id
        }
      }
    }
  }, [_vm._v("R" + _vm._s(_vm.item.number))])], 1), _c('div', {
    staticClass: "field-vehicle",
    attrs: {
      "slot": "n2"
    },
    slot: "n2"
  }, [_c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.vehicle.model))]), _c('router-link', {
    attrs: {
      "to": {
        name: 'vehicle',
        params: {
          id: _vm.item.vehicle.id
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.item.vehicle.plate))])], 1), _c('div', {
    attrs: {
      "slot": "n3"
    },
    slot: "n3"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'driver',
        params: {
          id: _vm.item.driver.id
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.item.driver.name) + " " + _vm._s(_vm.item.driver.surname))])], 1), _c('div', {
    staticClass: "field-reservation-start",
    attrs: {
      "slot": "n4"
    },
    slot: "n4"
  }, [_c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.start, 'DD MMMM')))]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.start, 'HH:mm')))])]), _c('div', {
    staticClass: "field-reservation-end",
    attrs: {
      "slot": "n5"
    },
    slot: "n5"
  }, [_c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.end, 'DD MMMM')))]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.end, 'HH:mm')))])])])], 1)]) : _vm._e(), (_vm.$is('sentinel')) ? _c('div', {
    staticClass: "sentinel"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('CardN', {
    attrs: {
      "showBullets": true,
      "showAction": true,
      "columns": 4
    }
  }, [_c('div', {
    staticClass: "field-reservation-dropdown-buttons",
    attrs: {
      "slot": "actionBullets"
    },
    slot: "actionBullets"
  }, [_c('dropdown', {
    attrs: {
      "icon": 'fa fa-ellipsis-v fa-2x action',
      "position": 'top'
    }
  }, [_c('reservation-action-buttons', {
    attrs: {
      "reservation": _vm.item
    }
  })], 1)], 1), _c('div', {
    staticClass: "field-reservation-info",
    attrs: {
      "slot": "n1"
    },
    slot: "n1"
  }, [_c('reservation-fields', {
    attrs: {
      "item": _vm.item,
      "fieldName": 'reservation-id',
      "type": 'reservation-id'
    }
  }), _c('driver', {
    attrs: {
      "type": 'onlyname',
      "item": _vm.item.driver
    }
  })], 1), _c('reservation-fields', {
    attrs: {
      "slot": "n1",
      "item": _vm.item,
      "fieldName": 'reservation-bmode'
    },
    slot: "n1"
  }), _c('reservation-fields', {
    attrs: {
      "slot": "n2",
      "fieldName": 'vehicle-info-no-img',
      "item": _vm.item
    },
    slot: "n2"
  }), _c('reservation-fields', {
    attrs: {
      "slot": "n3",
      "item": _vm.item,
      "fieldName": 'reservation-start-end'
    },
    slot: "n3"
  }), _c('reservation-fields', {
    attrs: {
      "slot": "n4",
      "item": _vm.item,
      "fieldName": 'reservation-distance'
    },
    slot: "n4"
  }), _c('reservation-fields', {
    attrs: {
      "slot": "n4",
      "item": _vm.item,
      "fieldName": 'reservation-cost'
    },
    slot: "n4"
  }), _c('a', {
    staticClass: "fa fa-globe fa-2x",
    attrs: {
      "slot": "n4"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('locate')
      }
    },
    slot: "n4"
  })], 1)], 1)])]) : _vm._e()]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "fa-stack",
    staticStyle: {
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-circle-o fa-stack-2x"
  }), _c('strong', {
    staticClass: "fa-stack-1x"
  }, [_vm._v("D")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "fa-stack",
    staticStyle: {
      "color": "red"
    }
  }, [_c('i', {
    staticClass: "fa fa-circle-o fa-stack-2x"
  }), _c('strong', {
    staticClass: "fa-stack-1x"
  }, [_vm._v("A")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-86d466b6!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/Reservation.vue
// module id = 2468
// module chunks = 1